import lodash from "lodash";

export const sortContactLenses = (contactLenses) => {
  return lodash.orderBy(
    contactLenses,
    [
      (contactLens) => {
        const splitName = contactLens.name.split("-");

        return Number(splitName[0]);
      },
    ],
    ["asc"]
  );
};
